import { render, staticRenderFns } from "./AddPrize.vue?vue&type=template&id=7a10e97c&scoped=true&"
import script from "./AddPrize.vue?vue&type=script&lang=ts&"
export * from "./AddPrize.vue?vue&type=script&lang=ts&"
import style0 from "./AddPrize.vue?vue&type=style&index=0&id=7a10e97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10e97c",
  null
  
)

export default component.exports